<template>
  <div class="user-profile-dropdown">
    <template v-if="$user.user">
      <b-dropdown
        right
        no-caret
        size="lg"
        variant="sm"
        class="d-none d-lg-block"
        menu-class="resize-dropdown"
        toggle-class="text-decoration-none"
      >
        <template #button-content>
          <div class="avatar">
            {{ $user.user.name[0] }}
          </div>
          <span>
            {{ $user.user.name.split(" ")[0] }}
          </span>
          <i class="ph ph-caret-down fs-16 text-dark-40" />
        </template>
        <dropdown-content @logout="$emit('logout')" @close="visible = false" />
      </b-dropdown>

      <button class="btn dropdown-toggle d-lg-none" @click="visible = true">
        <div class="avatar">
          {{ $user.user.name[0] }}
        </div>
        <span>
          {{ $user.user.name.split(" ")[0] }}
        </span>
        <i class="ph ph-caret-down fs-16 text-dark-40" />
      </button>
      <responsive-modal v-model="visible">
        <dropdown-content @logout="$emit('logout')" @close="visible = false" />
      </responsive-modal>
    </template>
  </div>
</template>
<script>
import DropdownContent from "./Content.vue";

export default {
  components: { DropdownContent },
  data() {
    return {
      visible: false
    };
  }
};
</script>
<style lang="scss" scoped>
.user-profile-dropdown {
  @media screen and (max-width: 991px) {
    overflow: hidden;
  }
  .avatar {
    width: 24px;
    height: 24px;
    font-size: 12px;
    overflow: hidden;
    border-radius: 50%;
    place-content: center;
    background-color: var(--bg-3);
  }

  ::v-deep.dropdown-menu.show {
    min-width: 265px !important;
    max-width: 365px !important;
    box-shadow: 0px 4.99685px 14.99054px 0px rgba(0, 0, 0, 0.15),
      0px 16px 32px 12px rgba(0, 0, 0, 0.08);
  }
}
</style>
